import Layout from '../../components/Layout/Main';
import Content from '../../components/Pages/ContentScripts';
import { displayName } from '../../config';

const ContentScripts = (): JSX.Element => {
  document.title = `${displayName}: Content Scripts`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
};

export default ContentScripts;
